module.exports = __webpack_public_path__ + "static/media/landing-page-mobile.d4b16592.png";